export default {
  title: 'Similar Judgments Search',
  desc: 'Click on tags below to inclued or exclude specific tags for similar judgment search.',
  search_desc: 'The search fuction will return judgments that matches the most of the included tags.',
  lang_support: '',
  show_tree: 'Tree view',
  hide_tree: 'Compact view',
  include: 'include',
  exclude: 'exclude',
  tag_indicator_help: 'What do the tag colors mean?',
  tag_dark: 'Darker tags',
  tag_dark_exp: ' are key concepts directly mentioned in the judgment',
  tag_light: 'Lighter tags',
  tag_light_exp: ' are associative tags inferred by the judgment',
  selected: 'Selected Search Criteria',
  result: 'Relevant Judgments',
  return_to_tags: 'Return to tags',
  beta_hint:'The tags for the judgment are generated using AI technologies. Click to read about this feature. Comments and reports are welcome via Feedback page.',
}